export default __webpack_public_path__ + "static/media/think.1fa17fe0.png";